import { memo } from 'react';

import { CornerDownLeftIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

import {
  workspaceAgentConsentDockApproveButton,
  workspaceAgentConsentDockEnterKey,
  workspaceAgentConsentDockEscapeKey,
  workspaceAgentConsentDockFooter,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';

export type WorkspaceAgentDockActionsProps = {
  approveLabel: string;
  cancelLabel?: string;
  hasDivider?: boolean;
  isApproveDisabled?: boolean;
  isApproveLoading?: boolean;
  onApprove: () => void;
  onCancel: () => void;
};

export const WorkspaceAgentDockActions = memo(
  ({
    approveLabel,
    cancelLabel = 'Cancel',
    hasDivider = true,
    isApproveDisabled = false,
    isApproveLoading = false,
    onApprove,
    onCancel,
  }: WorkspaceAgentDockActionsProps) => (
    <div className={workspaceAgentConsentDockFooter({ hasDivider })}>
      <Button
        appearance="outline"
        className="mr-auto gap-1 ads:text-primary text-gray-12"
        color="gray"
        data-testid="WORKSPACE_AGENT_CONSENT_DENY"
        onClick={onCancel}
        size="medium"
        type="button"
      >
        {cancelLabel}
        <kbd aria-hidden className={workspaceAgentConsentDockEscapeKey()}>
          Esc
        </kbd>
      </Button>
      <Button
        appearance="filled"
        className={cn('gap-2', workspaceAgentConsentDockApproveButton())}
        data-testid="WORKSPACE_AGENT_CONSENT_APPROVE"
        disabled={isApproveDisabled}
        isLoading={isApproveLoading}
        onClick={onApprove}
        size="medium"
        type="button"
      >
        {approveLabel}
        {isApproveDisabled ? null : (
          <kbd aria-hidden className={workspaceAgentConsentDockEnterKey()}>
            <CornerDownLeftIcon className="size-3" />
          </kbd>
        )}
      </Button>
    </div>
  ),
);

WorkspaceAgentDockActions.displayName = 'WorkspaceAgentDockActions';
